<template>
    <div class='touch-content'>
        <div class='reservation-area'>
            <div class='top-info-box'>
                <span class='info-txt'>현재시간 : {{ nowDate }} {{ nowTime }}</span>
                <button class='back-btn' @click='back'>돌아가기</button>
            </div>
            <!-- 예약정보 -->
            <div class='view-box'>
                <div class='info-cnt'>
                    <span class='tit'><strong>[{{ this.$route.query.name }}]</strong>회원님, 반갑습니다!<br>출석하실 프로그램을 선택해 주세요.</span>
                    <div class="right-info">
                        <ul class="list">
                            <li>
                                <span class="txt">락커명</span>
                                <span v-if="customerInfo.centerLocker" class="detail">{{ customerInfo.centerLocker.lockerGroupName }}</span>
                                <span v-else="customerInfo.centerLocker" class="detail">-</span>
                            </li>
                            <li>
                                <span class="txt">번호</span>
                                <span v-if="customerInfo.centerLocker" class="detail">{{ customerInfo.centerLocker.lockerNo }}</span>
                                <span v-else="customerInfo.centerLocker" class="detail">-</span>
                            </li>
                            <li>
                                <span class="txt">대여기간</span>
                                <span v-if="customerInfo.centerLocker" class="detail">
                                    {{ customerInfo.centerLocker.rentStartedAt }} ~ {{ customerInfo.centerLocker.rentEndedAt }} 
                                </span>
                                <span v-else="customerInfo.centerLocker" class="detail">-</span>
                            </li>
                            <li>
                                <span class="txt">남은기간</span>
                                <span v-if="customerInfo.centerLocker" class="detail">
                                    <strong class="red">{{ customerInfo.centerLocker.rentRemainDays }}일</strong>
                                </span>
                                <span v-else="customerInfo.centerLocker" class="detail"><strong class="red">-</strong></span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class='list-cnt'>
                    <ul>
                        <!--                        <li>-->
                        <!--                            &lt;!&ndash;-->
                        <!--                                <span class="ico type-1">[개인]</span>-->
                        <!--                                <span class="ico type-2">[그룹]</span>-->
                        <!--                                <span class="ico type-3">[패키지]</span>-->
                        <!--                                <span class="ico type-4">[회원권]</span>-->
                        <!--                                <span class="ico type-5">[듀엣]</span>-->
                        <!--                                <span class="ico type-6">[OT]</span>-->
                        <!--                            &ndash;&gt;-->
                        <!--                            <span class="ico type-4">[회원권] 12개월</span>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">유효기간</span>-->
                        <!--                                <span class="detail">2019.02.27 ~ 2020.02.27 (268 일 남음)</span>-->
                        <!--                            </div>-->
                        <!--                            <div class="btn-line">-->
                        <!--                                <button class="green">입장하기</button>-->
                        <!--                            </div>-->
                        <!--                        </li>-->
                        <!--                        <li>-->
                        <!--                            <span class="ico type-2">[그룹] 필라테스 주 2회</span>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">유효기간</span>-->
                        <!--                                <span class="detail">2019.02.27 ~ 2020.02.27<br>11/20 회 <span class="day">(268 일 남음)</span></span>-->
                        <!--                            </div>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">수업시간</span>-->
                        <!--                                <span class="detail">09:00 (담당 : 이지아)</span>-->
                        <!--                            </div>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">장소</span>-->
                        <!--                                <span class="detail">GX 룸</span>-->
                        <!--                            </div>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">프로그램</span>-->
                        <!--                                <span class="detail">매트 필라테스</span>-->
                        <!--                            </div>-->
                        <!--                            <div class="btn-line">-->
                        <!--                                <button class="blue" @click="goAttend">출석하기</button>-->
                        <!--                            </div>-->
                        <!--                        </li>-->
                        <!--                        <li>-->
                        <!--                            <span class="ico type-1">[개인] 주 2회 ~ 1개월</span>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">유효기간</span>-->
                        <!--                                <span class="detail">2019.02.27 ~ 2020.02.27<br>11/20 회 <span class="day red">(2 일 남음)</span></span>-->
                        <!--                            </div>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">수업시간</span>-->
                        <!--                                <span class="detail">10:30 (담당 : 이지아)</span>-->
                        <!--                            </div>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">장소</span>-->
                        <!--                                <span class="detail">GX 룸</span>-->
                        <!--                            </div>-->
                        <!--                            <div class="btn-line">-->
                        <!--                                <button class="blue" @click="goAttend">출석하기</button>-->
                        <!--                            </div>-->
                        <!--                        </li>-->
                        <!--                        <li>-->
                        <!--                            <span class="ico type-6">[OT] 그룹수업을 위한 사전레슨권 1회</span>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">유효기간</span>-->
                        <!--                                <span class="detail">2019.02.27 ~ 2020.02.27<br>11/20 회 <span class="day">(268 일 남음)</span></span>-->
                        <!--                            </div>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">수업시간</span>-->
                        <!--                                <span class="detail">09:00 (담당 : 이지아)</span>-->
                        <!--                            </div>-->
                        <!--                            <div class="btn-line">-->
                        <!--                                <button class="blue" @click="goAttend">출석하기</button>-->
                        <!--                            </div>-->
                        <!--                        </li>-->
                        <!--                        <li>-->
                        <!--                            <span class="ico type-2">[그룹] 주 2회 - 1개월</span>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">유효기간</span>-->
                        <!--                                <span class="detail">2019.02.27 ~ 2020.02.27<br>11/20 회 <span class="day">(268 일 남음 / <span class="blue">홀딩중</span>)</span></span>-->
                        <!--                            </div>-->
                        <!--                            <div class="btn-line">-->
                        <!--                                <button class="blue" disabled>출석하기</button>-->
                        <!--                            </div>-->
                        <!--                        </li>-->
                        <!--                        <li>-->
                        <!--                            <span class="ico type-1">[개인] 주 2회 ~ 1개월</span>-->
                        <!--                            <div class="line">-->
                        <!--                                <span class="tit">유효기간</span>-->
                        <!--                                <span class="detail">2019.02.27 ~ 2020.02.27<br>11/20 회 <span class="day red">(만료 7일 지남)</span></span>-->
                        <!--                            </div>-->
                        <!--                            <div class="btn-line">-->
                        <!--                                <span class="txt">유효기간이 종료되었습니다.</span>-->
                        <!--                            </div>-->
                        <!--                        </li>-->
                        <li v-for='(r,index) in reserveList' :key='index'>
                          <div style="display: flex;gap:10px;">
                            <span v-for='(t,index) in r.ticketType' :key="'t'+index" :class="{'ico':true, 'type-1':t == 'P', 'type-2': t === 'G', 'type-4': t === 'T', 'type-5': t === 'D', 'type-6': t === 'O', 'type-8': t === 'S',
                                }">{{ convertTicket(r.ticketType) }} {{
                                    r.productName
                                }}</span>
                          </div>

                            <div class='line'>
                                <span class='tit'>유효기간</span>
                                <span class='detail'>{{ r.expireStartDate | timestampFilter
                                    }} ~ {{ r.expireEndDate | timestampFilter }}
                                    <br>
                                    <span
                                        v-if="r.lessonCountType === 'T'">총 {{ 
                                            // r.lessonJoinCount + r.lessonAbsentCount
                                            r.contractSeq
                                        }}/{{
                                            r.lessonCount
                                        }} 회 </span>
                                    <span v-else-if="r.lessonCountType === 'W'">주 {{ r.lessonCount }} 회 </span>
                                    <span v-else-if="r.lessonCountType === 'U'">무제한 </span>
                                    <span v-if='r.expireDays > 0'
                                          :class="{'day':true, 'red': r.expireDays < 3}">({{ r.expireDays }}일 남음<span
                                        v-if="r.expirePlusType === 'H'"> /</span><span v-if="r.expirePlusType === 'H'"
                                                                                       class='blue'> 홀딩중</span>)</span>
                                </span>
                                <span v-if='r.expireDays < 0 && r.expireDays >= -7' class='day red'>(만료 {{
                                        -1 * r.expireDays
                                    }}일 지남)</span>
                            </div>
                            <div v-if='r.lessonStartTime !== null' class='line'>
                                <span class='tit'>수업시간</span>
                                <span class='detail'>{{ r.lessonStartTime | timeCutter }} (담당 : {{ r.lessonStaffName
                                    }})</span>
                            </div>
                            <div v-if='r.centerRoomNames !== null' class='line'>
                                <span class='tit'>장소</span>
                                <span class='detail'>{{ convertRoom(r.centerRoomNames) }}</span>
                            </div>
                            <div v-if="r.lessonName && (r.ticketType === 'G' || r.ticketType === 'C')" class='line'>
                                <span class='tit'>프로그램</span>
                                <span class='detail'>{{ r.lessonName }}</span>
                            </div>
                            <div v-if="r.expirePlusType !== 'H'" class='btn-line'>
                                <span v-if='r.expireDays < 0' class='txt'>유효기간이 종료되었습니다.</span>
                                <button
                                    v-else-if="(r.ticketType ==='T') || (r.ticketType !== 'T' && !r.lessonDate && !r.noReservationEnterYn)"
                                    class='green'
                                    :disabled='isButtonDisable'
                                    @click='touchEntrance(r.centerContractId,r.centerProductId,r.centerLessonScheduleId)'>
                                    입장하기
                                </button><!-- 입장권 -->
                                <span v-if="timeFilter(r.expireEndDate) === today && !r.centerLessonScheduleId" class='txt red'>당일만료</span>
                                <button
                                    v-if="r.centerLessonScheduleId"
                                    class="blue"
                                    :disabled='isButtonDisable'
                                    @click='touchAttendance(r.centerContractId,r.centerProductId,r.centerLessonScheduleId)'>
                                    출석하기
                                </button><!-- 그 외 -->

                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';

export default {
    name: 'touchReservation',
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            nowDate: moment().format('YYYY.MM.DD'),
            today: moment().format('YYYY-MM-DD'),
            nowTime: moment().format('hh:mm:ss'),
            centerCustomerId: this.$route.query.custId,
            centerCustomerName: this.$route.query.name,
            reserveList: '',
            customerInfo: {}, // 회원 정보
            centerId: this.$route.query.centerId,
            isButtonDisable: false,
        };
    },
    mounted() {
        setInterval(
            () => {
                this.nowTime = moment().format('hh:mm:ss');
            }
            , 1000,
        );
        Promise.allSettled([
            this.fetchCustomerDetail(), // 회원정보 가져오기
            this.onSearchList()
        ]);
    },
    methods: {
      timeFilter(value){
        if (value === null || value === '' || value === undefined) {
          return value;
        }

        function addZero(target) {
          // 9 이하의 숫자는 0 붙이기
          const num = parseInt(target);
          const str = num > 9 ? num : `0${num}`;
          return str.toString();
        }

        const b = value.split(/\D/);
        --b[1];
        b[6] = b[6].substr(0, 3);
        const d = new Date(Date.UTC(...b));
        return `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(
            d.getDate()
        )}`;
      },
        async touchAttendance(c, p, l) {
            try {
                this.isButtonDisable = true;
                const { data } = await this.fetchTouchAttendance(c, p, l);
                console.log('dataa', data);
                if (data == true) {
                    this.$router.push({
                        path: 'complete',
                        query: {
                            name: this.centerCustomerName,
                        },
                    }); // 뒤로가기
                } else {
                    alert('출석 승인되지 않았습니다.');
                }
                this.isButtonDisable = false;
            } catch (e) {
                console.error(e);
                console.log('터치 에러입니다.');
            }
        },
        fetchTouchAttendance(c, p, l) { // 회원권이 아닌 경우
            return api.put(`/admin/api/center/${this.cId}/touch/monitor/customer/${this.centerCustomerId}/touch/attend`, {
                centerContractId: c,
                centerProductId: p,
                centerLessonScheduleId: l,
            });
        },
        async touchEntrance(c, p, l) {
            try {
                this.isButtonDisable = true;
                const { data } = await this.fetchTouchEntrance(c, p, l);
                let  {rc, rm} = data;

                if (rc === true) {
                    this.$router.push({
                        path: 'complete',
                        query: {
                            name: this.centerCustomerName,
                        },
                    }); // 뒤로가기
                } else {
                    alert(rm ||'입장하지 못했습니다.');
                }
                this.isButtonDisable = false;
            } catch (e) {
                console.error(e);
                console.log('터치 에러입니다.');
            }
        },
        fetchTouchEntrance(c, p, l) {
            return api.post(`/admin/api/center/${this.cId}/touch/monitor/customer/${this.centerCustomerId}/touch/entrance`, {
                centerContractId: c,
                centerProductId: p,
                centerLessonScheduleId: l,
            });
        },

        back() {
            this.$router.push({ path: 'main' }); // 뒤로가기
        },
        goAttend() {
            this.$router.push({ path: 'complete' }); // 뒤로가기
        },
        async onSearchList() {
            try {
                const { data } = await this.getSearchLsit();
                console.log(data);
                this.reserveList = data;

                if (!this.reserveList || this.reserveList.length === 0) {
                    this.$router.replace({
                        path: 'nodata',
                        query: {
                            name: this.centerCustomerName,
                        },
                    });
                }
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getSearchLsit() {
            return api.get(`/admin/api/center/${this.cId}/touch/monitor/customer/${this.centerCustomerId}/schedule/list`);
        },
        convertTicket(val) {
            switch (val) {
                case 'P':
                    return '[개인]';
                    break;
                case 'O':
                    return '[OT]';
                    break;
                case 'D':
                    return '[듀엣]';
                    break;
                case 'G':
                    return '[그룹]';
                    break;
                case 'T':
                    return '[회원권]';
                    break;
                case 'S':
                    return '[운동복]';
                    break;
            }
        },
        convertRoom(roomNames) {
            const names = roomNames.split(',');
            const result = [];

            names.forEach((item) => {
                if (result && (result.length === 0 || !result.includes(item))) {
                    result.push(item);
                }
            });

            return result.join('/');
        },
        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                for(let i in this.customerInfo.centerLockers) {
                    if(this.customerInfo.centerLockers[i].lockerStatus != 'F') {
                        this.customerInfo.centerLocker = this.customerInfo.centerLockers[i];
                        const rentEndedDay = moment(this.customerInfo.centerLocker.rentEndedAt);
                        const currentDate = moment();
                        this.customerInfo.centerLocker.rentRemainDays = rentEndedDay.diff(currentDate,"days")
                        // return (remainDays >= 0) ? `-${remainDays}` : String(remainDays).replace('-', '+');

                        break;
                    }
                }
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.centerCustomerId}`);
        },
    },
};
</script>
<style lang='scss' scoped>
</style>
